import React from 'react';
import TweenOne from 'rc-tween-one';
import QueueAnim from 'rc-queue-anim';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from '../../utils';

/* replace-start */
import './index.less';
/* replace-end */
class Banner6 extends React.PureComponent {
  render() {
    const { ...tagProps } = this.props;
    const { dataSource } = tagProps;
    delete tagProps.dataSource;
    delete tagProps.isMobile;

    return (
      <OverPack
        {...tagProps}
        {...dataSource.wrapper}
      >
        <div {...dataSource.bg} data-edit="image">
          <img src={dataSource.bg.children} width="100%" alt="img" />
        </div>
        <div {...dataSource.page}>
          <div
            className="content"
          >
            <TweenOne
              animation={{
                y: 0,
                duration: 800,
              }}
              style={{ transform: 'translateY(-50vw)' }}
              key="logo"
              {...dataSource.logo}
              data-edit="image"
            >
              <img src={dataSource.logo.children} width="100%" alt="img" />
            </TweenOne>
            <TweenOne
              animation={{
                scale: 1,
                duration: 800,
              }}
              style={{ transform: 'scale(2)' }}
              {...dataSource.title}
            >
              {
              dataSource.title.children.map(getChildrenToRender)
            }
            </TweenOne>
            <TweenOne
              animation={{
                y: 0,
                duration: 800,
              }}
              style={{ transform: 'translateY(50vw)' }}
              {...dataSource.box}
            >
              <QueueAnim
                type="bottom"
                delay={800}
                className="box-anim"
              >
                {
                  dataSource.box.children.map(getChildrenToRender)
                }
              </QueueAnim>

            </TweenOne>
          </div>
        </div>

      </OverPack>
    );
  }
}
export default Banner6;
